import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, ArrowRight } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-24 md:py-28 bg-darkGreen relative overflow-hidden" data-id="element-159">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-4xl opacity-10 pointer-events-none" data-id="element-160">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-vibrantGreen rounded-full mix-blend-screen filter blur-3xl" data-id="element-161"></div>
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-vibrantGreen rounded-full mix-blend-screen filter blur-3xl" data-id="element-162"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-163">
        <div className="max-w-3xl mx-auto" data-id="element-164">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-[2rem] p-8 md:p-12 shadow-2xl relative" data-id="element-165">
            {/* Urgency Badge */}
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-urgencyRed text-white px-6 py-2 rounded-full font-bold text-sm md:text-base shadow-lg whitespace-nowrap animate-pulse" data-id="element-166">
              🔥 OFERTA VÁLIDA SOLO POR HOY
            </div>

            <div className="text-center mb-8 mt-4" data-id="element-167">
              <h2 className="text-3xl md:text-4xl font-black text-darkGreen mb-2 font-montserrat" data-id="element-168">
                Pack Completo: 30 Cenas Proteicas + 20 Bonos
              </h2>
              <p className="text-gray-500 line-through text-xl md:text-2xl font-medium mt-6" data-id="element-169">
                Valor real: $197 USD
              </p>
              <div className="flex items-center justify-center gap-4 mt-2" data-id="element-170">
                <span className="text-gray-600 font-bold text-xl uppercase" data-id="element-171">
                  Hoy:
                </span>
                <span className="text-6xl md:text-7xl font-black text-vibrantGreen font-montserrat tracking-tighter" data-id="element-172">
                  $9{' '}
                  <span className="text-2xl md:text-3xl text-gray-500 font-bold" data-id="element-173">
                    USD
                  </span>
                </span>
              </div>
            </div>

            <div className="space-y-6 mb-10" data-id="element-174">
              <a href="https://recetasexpress.store" target="_blank" rel="noopener noreferrer" className="w-full group relative flex items-center justify-center bg-vibrantGreen hover:bg-[#40a075] text-darkGreen font-black text-xl md:text-2xl py-6 px-8 rounded-2xl shadow-[0_0_30px_rgba(82,183,136,0.4)] hover:shadow-[0_0_40px_rgba(82,183,136,0.6)] transition-all duration-300 transform hover:-translate-y-1 overflow-hidden" data-id="element-175">
                <div className="absolute inset-0 bg-white/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-out" data-id="element-176"></div>
                <span className="relative z-10 flex items-center gap-3" data-id="element-177">
                  DESCARGAR AHORA
                  <ArrowRight className="w-7 h-7 group-hover:translate-x-1 transition-transform" data-id="element-178" />
                </span>
              </a>

              <div className="flex flex-col items-center gap-3 text-sm text-gray-500 font-medium" data-id="element-179">
                <div className="flex items-center gap-2" data-id="element-180">
                  <CreditCard className="w-5 h-5" data-id="element-181" />
                  <span data-id="element-182">Pago 100% Seguro y Encriptado</span>
                </div>
                {/* Simulated payment icons */}
                <div className="flex gap-2 opacity-60" data-id="element-183">
                  <div className="w-10 h-6 bg-gray-200 rounded flex items-center justify-center text-[10px] font-bold" data-id="element-184">
                    VISA
                  </div>
                  <div className="w-10 h-6 bg-gray-200 rounded flex items-center justify-center text-[10px] font-bold" data-id="element-185">
                    MC
                  </div>
                  <div className="w-10 h-6 bg-gray-200 rounded flex items-center justify-center text-[10px] font-bold" data-id="element-186">
                    AMEX
                  </div>
                  <div className="w-10 h-6 bg-gray-200 rounded flex items-center justify-center text-[10px] font-bold" data-id="element-187">
                    PAYPAL
                  </div>
                </div>
              </div>
            </div>

            {/* Guarantee */}
            <div className="bg-lightGreen rounded-2xl p-6 flex items-start md:items-center gap-4 border border-vibrantGreen/30" data-id="element-188">
              <ShieldCheck className="w-12 h-12 text-vibrantGreen flex-shrink-0" data-id="element-189" />
              <div data-id="element-190">
                <h4 className="font-bold text-darkGreen text-lg mb-1" data-id="element-191">
                  Garantía de satisfacción 7 días
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-192">
                  Si el recetario no cumple tus expectativas, te devolvemos el
                  100% de tu dinero sin hacer preguntas. Tienes cero riesgo.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}